import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-delete-filter',
  templateUrl: './dialog-delete-filter.component.html',
  styleUrls: ['./dialog-delete-filter.component.scss']
})
export class DialogDeleteFilterComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data:any, private dialogRef: MatDialogRef<DialogDeleteFilterComponent>,) { }
  ngOnInit(): void {
  }

  cancel(){
    this.dialogRef.close()
  }

  delete(){
    this.dialogRef.close('delete');
  }
}
